import { render } from "./BooksList.vue?vue&type=template&id=1301f740&scoped=true"
import script from "./BooksList.vue?vue&type=script&lang=js"
export * from "./BooksList.vue?vue&type=script&lang=js"

import "./BooksList.vue?vue&type=style&index=0&id=1301f740&scoped=true&lang=css"

import exportComponent from "C:\\Surilova\\FrontEnd\\Bookshelf-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1301f740"]])

export default __exports__